import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/Header";
import { BottomNav } from "@/components/BottomNav";

export const Route = createFileRoute("/faq")({
  head: () => ({
    meta: [
      { title: "FAQ — PataTasks" },
      {
        name: "description",
        content:
          "Frequently asked questions about PataTasks app and web testing platform, test access, and payments.",
      },
    ],
  }),
  component: FaqPage,
});

function FaqPage() {
  const faqs = [
    {
      q: "How do I accept tests on PataTasks?",
      a: "Browse available app tests or web app tests, click View Test to see full details, then click Accept Test. A one-time access fee is paid via IntaSend to accept tests.",
    },
    {
      q: "When do I get paid?",
      a: "You get paid instantly upon successful completion. The test reward amount is shown on each test card and is paid directly to you.",
    },
    {
      q: "What payment methods are available for payouts?",
      a: "We support local mobile money, PayPal, and bank transfers. You can choose your preferred payout method when withdrawing from your wallet.",
    },
    {
      q: "Is my payment secure?",
      a: "Yes. All payments are processed securely through IntaSend, a trusted payment provider.",
    },
    {
      q: "Do I pay for every test I accept?",
      a: "Yes. Each test has its own access fee which grants you access to that specific test's instructions and submission form.",
    },
    {
      q: "Can I get a refund after paying?",
      a: "The access fee is non-refundable once paid. It helps us maintain the platform and connect testers with developers.",
    },
    {
      q: "What categories of tests are available?",
      a: "We offer app tests for mobile apps and web app tests for websites. Categories include music, social, browsing, education, coding, ecommerce, productivity, and more.",
    },
  ];

  return (
    <div className="bg-background pb-20 md:pb-0">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 py-10">
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-foreground mb-6 sm:mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4 sm:space-y-6">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl border border-blue-200 bg-white p-4 sm:p-5 shadow-sm"
            >
              <h3 className="font-semibold text-foreground mb-2 text-base sm:text-lg">{faq.q}</h3>
              <p className="text-slate-600 text-sm sm:text-base leading-relaxed">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
      <BottomNav />
    </div>
  );
}
